import {FormattedMessage} from '@pinecast/i18n';
import {useCSS} from '@pinecast/styles';

import StepHeading from './StepHeading';

const TipJarDone = () => {
  const css = useCSS();
  return (
    <div className={css({padding: '40px 0', textAlign: 'center'})}>
      <StepHeading centered>
        <FormattedMessage
          description="Title when a membership is updated"
          defaultMessage="We've updated your subscription."
        />
      </StepHeading>
      <p className={css({margin: 0})}>
        <FormattedMessage
          description="Copy when a membership is updated"
          defaultMessage="Your changes have been saved. You'll be billed accordingly."
        />
      </p>
    </div>
  );
};

export default TipJarDone;
